import { useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Form } from "react-final-form";
import { SpecialProjectCaseAssignmentForm } from "./SpecialProjectCaseAssignmentForm";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { camelizeKeys, snakifyKeys } from "../../../util/helpers";

export const EditSpecialProjectCaseAssignmentModal = ({ specialProject, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const initialValues = {
    lab_id: specialProject?.lab?.id,
    payor_ids: specialProject?.payors?.map((payor) => payor.id),
    account_ids: specialProject?.accounts?.map((account) => account.id),
    test_ids: specialProject?.tests?.map((test) => test.id),
  };

  const toggleModal = () => setOpen((x) => !x);

  const handleUpdate = async (params) => {
    try {
      const res = await api.patch(`/admin/special_project_case_assignment_configs/${specialProject.id}`, {
        special_project_case_assignment_config: snakifyKeys(params),
      });

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal size="lg" isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Special Project {specialProject.id}</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleUpdate} initialValues={camelizeKeys({ ...specialProject, ...initialValues })}>
            {(props) => <SpecialProjectCaseAssignmentForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
